import { types } from "./types";

export const createInternalHref = ({
  href = "",
  locale,
  type,
  isOutOfScope,
}) => {
  const typePart = types[type] ? `/${types[type][locale]}` : "/";
  if (isOutOfScope) {
    return `${process.env.NEXT_PUBLIC_INEO_DOMAIN}${typePart}${href}`.replace(
      /\/$/g,
      ""
    );
  }
  if (locale === "en") return `${typePart}${href}`.replace(/\/$/g, "");
  return `/${locale}${typePart}${href}`.replace(/\/$/g, "");
};
